// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smallfonts {\n    font-size: small;\n}\n.mediumfonts {\n    font-size: medium;\n}\n.largefonts {\n    font-size: medium;\n}\n.header-font {\n    font-size: 14px;\n    font-weight: 400;\n}\n.lora-font {\n    font-family: 'Lora', serif;\n}\n#blue {\n    color: #1565C0\n}\n#bold {\n    font-weight: bold;\n}\n#bottom {\n    bottom: 0;\n}\n.font-black {\n    color: black;\n}\n", ""]);
// Exports
module.exports = exports;
